import React, { useEffect, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { Breadcrumb, Col, Row, Button, Alert, Spinner } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage, useField } from "formik";
import * as Yup from "yup";

import API from "../Utility";
import PubHubAsset from "../PubHubAsset";

export default function ThemeView({ projectObject, setProjectObject }) {
  let { project } = useParams();
  const [submitSuccess, setSubmitSuccess] = useState(null);
  const [submitError, setSubmitError] = useState("");
  const [submittingForm, setSubmittingForm] = useState(false);
  const [projectConfig, setProjectConfig] = useState(
    projectObject && projectObject.config ? projectObject.config : { theme: {} }
  );

  useEffect(() => {
    setProjectObject({
      ...projectObject,
      ...{
        config: projectConfig,
      },
    });
  }, [projectConfig]);

  let featuredImageLegacy = undefined;
  if (projectObject && projectObject.featuredImagePath) {
    featuredImageLegacy = {
      path: projectObject.featuredImagePath,
      name: projectObject.featuredImagePath,
      size: 0,
    };
  }
  const [leftIconAsset, setLeftIconAsset] = useState(
    projectObject &&
      projectObject.config &&
      projectObject.config.theme &&
      projectObject.config.theme.navigation &&
      projectObject.config.theme.navigation.leftIcon &&
      projectObject.config.theme.navigation.leftIcon.image
      ? projectObject.config.theme.navigation.leftIcon.image
      : undefined
  );
  const [rightIconAsset, setRightIconAsset] = useState(
    projectObject &&
      projectObject.config &&
      projectObject.config.theme &&
      projectObject.config.theme.navigation &&
      projectObject.config.theme.navigation.rightIcon &&
      projectObject.config.theme.navigation.rightIcon.image
      ? projectObject.config.theme.navigation.rightIcon.image
      : undefined
  );
  const [leftIconWidth, setLeftIconWidth] = useState(
    projectObject &&
      projectObject.config &&
      projectObject.config.theme &&
      projectObject.config.theme.navigation &&
      projectObject.config.theme.navigation.leftIcon &&
      projectObject.config.theme.navigation.leftIcon.width
      ? projectObject.config.theme.navigation.leftIcon.width
      : undefined
  );
  const [leftIconHeight, setLeftIconHeight] = useState(
    projectObject &&
      projectObject.config &&
      projectObject.config.theme &&
      projectObject.config.theme.navigation &&
      projectObject.config.theme.navigation.leftIcon &&
      projectObject.config.theme.navigation.leftIcon.height
      ? projectObject.config.theme.navigation.leftIcon.height
      : undefined
  );
  const [rightIconWidth, setRightIconWidth] = useState(
    projectObject &&
      projectObject.config &&
      projectObject.config.theme &&
      projectObject.config.theme.navigation &&
      projectObject.config.theme.navigation.rightIcon &&
      projectObject.config.theme.navigation.rightIcon.width
      ? projectObject.config.theme.navigation.rightIcon.width
      : undefined
  );
  const [rightIconHeight, setRightIconHeight] = useState(
    projectObject &&
      projectObject.config &&
      projectObject.config.theme &&
      projectObject.config.theme.navigation &&
      projectObject.config.theme.navigation.rightIcon &&
      projectObject.config.theme.navigation.rightIcon.height
      ? projectObject.config.theme.navigation.rightIcon.height
      : undefined
  );
  const [menuIconScale, setMenuIconScale] = useState(
    projectObject &&
      projectObject.config &&
      projectObject.config.theme &&
      projectObject.config.theme.navigation &&
      projectObject.config.theme.navigation.menuIcon &&
      projectObject.config.theme.navigation.menuIcon.scale
      ? projectObject.config.theme.navigation.menuIcon.scale
      : undefined
  );
  const [featuredImageAsset, setFeaturedImageAsset] = useState(
    projectObject &&
      projectObject.customCode &&
      projectObject.customCode.featuredImage &&
      projectObject.customCode.featuredImage !== ""
      ? projectObject.customCode.featuredImage
      : featuredImageLegacy
  );
  const [navigationLogoAsset, setNavigationLogoAsset] = useState(
    projectObject &&
      projectObject.customCode &&
      projectObject.customCode.logoImage
      ? projectObject.customCode.logoImage
      : undefined
  );
  const [faviconAsset, setFaviconAsset] = useState(
    projectObject &&
      projectObject.customCode &&
      projectObject.customCode.favicon
      ? projectObject.customCode.favicon
      : undefined
  );
  const [loadingIconAsset, setLoadingIconAsset] = useState(
    projectObject &&
      projectObject.customCode &&
      projectObject.customCode.loadingIcon
      ? projectObject.customCode.loadingIcon
      : undefined
  );

  // Initialize form validation
  let formValidation = {};

  // Initialize form fields
  let formFields = {
    primaryFont:
      projectConfig && projectConfig.theme && projectConfig.theme.primaryFont
        ? projectConfig.theme.primaryFont
        : undefined,
    primaryColor:
      projectConfig && projectConfig.theme && projectConfig.theme.primaryColor
        ? projectConfig.theme.primaryColor
        : undefined,
    secondaryColor:
      projectConfig && projectConfig.theme && projectConfig.theme.secondaryColor
        ? projectConfig.theme.secondaryColor
        : undefined,
    leftIconWidth: leftIconWidth,
    leftIconHeight: leftIconHeight,
    rightIconWidth: rightIconWidth,
    rightIconHeight: rightIconHeight,
    leftIconAsset: leftIconAsset,
    rightIconAsset: rightIconAsset,
    menuIconScale: menuIconScale,
    featuredImageAsset: featuredImageAsset,
    navigationLogoAsset: navigationLogoAsset,
    faviconAsset: faviconAsset,
    loadingIconAsset: loadingIconAsset
  };

  const updateProjectTheme = async (values) => {
    try {
      const apiCallConfig = {
        url: `/admin/${project}/update`,
        data: values,
      };
      setSubmittingForm(true);
      const response = await API.put(apiCallConfig);
      if (response) {
        if (response === "Project updated successfully") {
          // success
          setSubmitSuccess("Theme updated successfully");
        } else {
          setSubmitError(response.message || response);
        }
        setSubmittingForm(false);
      }
    } catch (error) {
      if (error.response) {
        setSubmitError(error.response.data.message);
      } else {
        setSubmitError("An error occurred, please try again");
      }
      setSubmittingForm(false);
    }
  };

  const handleSubmit = (values) => {
    let formattedData = {
      featuredImagePath: null,
      config: projectConfig ? {
        ...projectConfig,
        theme: {}
      } : {},
      customCode: projectObject && projectObject.customCode ? {
        ...projectObject.customCode,
        featuredImage: null,
        logoImage: null,
        logoImagePath: null,
        favicon: null,
        faviconPath: null,
        loadingIcon: null,
        loadingIconPath: null
      } : {}
    };
    setSubmitSuccess(null);
    setSubmitError(null);
    if (values) {
      if (values.primaryFont && values.primaryFont !== "") {
        formattedData.config = formattedData.config || { theme: {} };
        formattedData.config.theme.primaryFont = values.primaryFont;
      }
      if (values.primaryColor && values.primaryColor !== "") {
        formattedData.config = formattedData.config || { theme: {} };
        formattedData.config.theme.primaryColor = values.primaryColor;
      }
      if (values.secondaryColor && values.secondaryColor !== "") {
        formattedData.config = formattedData.config || { theme: {} };
        formattedData.config.theme.secondaryColor = values.secondaryColor;
      }
    }
    if (leftIconAsset || rightIconAsset || values.menuIconScale) {
      if (!formattedData.config.theme) {
        formattedData.config.theme = {};
      }
      if (!formattedData.config.theme.navigation) {
        formattedData.config.theme.navigation = {};
      }
      if (leftIconAsset) {
        if (!formattedData.config.theme.navigation.leftIcon) {
          formattedData.config.theme.navigation.leftIcon = {};
        }
        formattedData.config.theme.navigation.leftIcon.image = leftIconAsset;
        if (values.leftIconWidth && values.leftIconWidth !== "") {
          formattedData.config.theme.navigation.leftIcon.width =
            values.leftIconWidth;
        }
        if (values.leftIconHeight && values.leftIconHeight !== "") {
          formattedData.config.theme.navigation.leftIcon.height =
            values.leftIconHeight;
        }
      }
      if (rightIconAsset) {
        if (!formattedData.config.theme.navigation.rightIcon) {
          formattedData.config.theme.navigation.rightIcon = {};
        }
        formattedData.config.theme.navigation.rightIcon.image = rightIconAsset;
        if (values.rightIconWidth && values.rightIconWidth !== "") {
          formattedData.config.theme.navigation.rightIcon.width =
            values.rightIconWidth;
        }
        if (values.rightIconHeight && values.rightIconHeight !== "") {
          formattedData.config.theme.navigation.rightIcon.height =
            values.rightIconHeight;
        }
      }
      if (values.menuIconScale) {
        if (!formattedData.config.theme.navigation.menuIcon) {
          formattedData.config.theme.navigation.menuIcon = {};
        }
        formattedData.config.theme.navigation.menuIcon.scale =
          values.menuIconScale;
      }
    }
    if (featuredImageAsset && featuredImageAsset.path) {
      formattedData.customCode.featuredImage = featuredImageAsset;
      formattedData.featuredImagePath = featuredImageAsset.path;
    } else if (featuredImageAsset && !featuredImageAsset.path) {
      formattedData.customCode.featuredImage = {
        path: featuredImageAsset,
        name: featuredImageAsset,
        size: 0,
      };
      formattedData.featuredImagePath = featuredImageAsset;
    }
    if (navigationLogoAsset || faviconAsset || loadingIconAsset) {
      if (navigationLogoAsset) {
        formattedData.customCode.logoImage = navigationLogoAsset;
        formattedData.customCode.logoImagePath = navigationLogoAsset.path;
      }
      if (faviconAsset) {
        formattedData.customCode.favicon = faviconAsset;
        formattedData.customCode.faviconPath = faviconAsset.path;
      }
      if (loadingIconAsset) {
        formattedData.customCode.loadingIcon = loadingIconAsset;
        formattedData.customCode.loadingIconPath = loadingIconAsset.path;
      }
    }
    if (
      values &&
      !values.primaryFont &&
      !values.primaryColor &&
      !values.secondaryColor &&
      !values.leftIconWidth &&
      !values.leftIconHeight &&
      !values.rightIconWidth &&
      !values.rightIconHeight &&
      !values.menuIconScale
    ) {
      formattedData.config = formattedData.config || { theme: undefined };
    }
    if (formattedData && formattedData.config) {
      setProjectConfig(formattedData.config);
    }
    updateProjectTheme(formattedData);
  };

  return (
    <Row>
      <Col>
        <Formik
          initialValues={formFields}
          validationSchema={Yup.object().shape(formValidation)}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            handleSubmit(values);
          }}
        >
          {({ touched, errors, isSubmitting }) => (
            <Form noValidate>
              {projectObject.customFonts &&
                projectObject.customFonts.length > 0 && (
                <div className="form-group">
                  <label htmlFor="primaryFont">Primary Font</label>
                  <Field
                    as="select"
                    name="primaryFont"
                    className={`form-control ${
                      touched.primaryFont && errors.primaryFont
                        ? "is-invalid"
                        : ""
                    } ${
                      touched.primaryFont && !errors.primaryFont
                        ? "is-valid"
                        : ""
                    }`}
                  >
                    <>
                      <option value={null}>Choose a font</option>
                      {projectObject.customFonts.map(function (item, index) {
                        return (
                          <option key={index} value={item.reference}>
                            {item.reference}
                          </option>
                        );
                      })}
                    </>
                  </Field>
                  <ErrorMessage
                    component="div"
                    name="primaryFont"
                    className="invalid-feedback"
                  />
                </div>
              )}

              <div className="form-group">
                <label htmlFor="primaryColor">Primary Colour</label>
                <Field
                  type="text"
                  name="primaryColor"
                  placeholder="Primary Colour (e.g. white / #fff / rgba(255, 255, 255, 1))"
                  className={`form-control ${
                    touched.primaryColor && errors.primaryColor
                      ? "is-invalid"
                      : ""
                  } ${
                    touched.primaryColor && !errors.primaryColor
                      ? "is-valid"
                      : ""
                  }`}
                ></Field>
                <ErrorMessage
                  component="div"
                  name="primaryColor"
                  className="invalid-feedback"
                />
              </div>

              <div className="form-group">
                <label htmlFor="secondaryColor">Secondary Colour</label>
                <Field
                  type="text"
                  name="secondaryColor"
                  placeholder="Secondary Colour (e.g. white / #fff / rgba(255, 255, 255, 1))"
                  className={`form-control ${
                    touched.secondaryColor && errors.secondaryColor
                      ? "is-invalid"
                      : ""
                  } ${
                    touched.secondaryColor && !errors.secondaryColor
                      ? "is-valid"
                      : ""
                  }`}
                ></Field>
                <ErrorMessage
                  component="div"
                  name="secondaryColor"
                  className="invalid-feedback"
                />
              </div>

              <div className="form-group">
                <label htmlFor="menuIconScale">Menu Icon Scale</label>
                <Field
                  type="number"
                  name="menuIconScale"
                  placeholder="Menu Icon Scale (e.g. 0.9 / 1.5 / 2)"
                  className={`form-control ${
                    touched.menuIconScale && errors.menuIconScale
                      ? "is-invalid"
                      : ""
                  } ${
                    touched.menuIconScale && !errors.menuIconScale
                      ? "is-valid"
                      : ""
                  }`}
                ></Field>
                <ErrorMessage
                  component="div"
                  name="menuIconScale"
                  className="invalid-feedback"
                />
              </div>

              <div className="form-group">
                <label>Left Navigation Icon</label>
                <div className={`form-control asset-selector`}>
                  <PubHubAsset
                    asset={leftIconAsset}
                    onChanged={(asset) => {
                      setLeftIconAsset(asset);
                    }}
                    maxFileSizeInBytes={5242880}
                    // acceptMimeTypes={["image/png", "image/jpeg"]}
                    assetType="image"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="leftIconWidth">
                  Left Navigation Icon Width (In Pixels)
                </label>
                <Field
                  type="number"
                  name="leftIconWidth"
                  placeholder="Left Navigation Icon Width (e.g. 50)"
                  disabled={leftIconAsset ? false : true}
                  className={`form-control ${
                    touched.leftIconWidth && errors.leftIconWidth
                      ? "is-invalid"
                      : ""
                  } ${
                    touched.leftIconWidth && !errors.leftIconWidth
                      ? "is-valid"
                      : ""
                  }`}
                ></Field>
                <ErrorMessage
                  component="div"
                  name="leftIconWidth"
                  className="invalid-feedback"
                />
              </div>

              <div className="form-group">
                <label htmlFor="leftIconHeight">
                  Left Navigation Icon Height (In Pixels)
                </label>
                <Field
                  type="number"
                  name="leftIconHeight"
                  placeholder="Left Navigation Icon Height (e.g. 50)"
                  disabled={leftIconAsset ? false : true}
                  className={`form-control ${
                    touched.leftIconHeight && errors.leftIconHeight
                      ? "is-invalid"
                      : ""
                  } ${
                    touched.leftIconHeight && !errors.leftIconHeight
                      ? "is-valid"
                      : ""
                  }`}
                ></Field>
                <ErrorMessage
                  component="div"
                  name="leftIconHeight"
                  className="invalid-feedback"
                />
              </div>

              <div className="form-group">
                <label>Right Navigation Icon</label>
                <div className={`form-control asset-selector`}>
                  <PubHubAsset
                    asset={rightIconAsset}
                    onChanged={(asset) => {
                      setRightIconAsset(asset);
                    }}
                    maxFileSizeInBytes={5242880}
                    // acceptMimeTypes={["image/png", "image/jpeg"]}
                    assetType="image"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="rightIconWidth">
                  Right Navigation Icon Width (In Pixels)
                </label>
                <Field
                  type="number"
                  name="rightIconWidth"
                  placeholder="Right Navigation Icon Width (e.g. 50)"
                  disabled={rightIconAsset ? false : true}
                  className={`form-control ${
                    touched.rightIconWidth && errors.rightIconWidth
                      ? "is-invalid"
                      : ""
                  } ${
                    touched.rightIconWidth && !errors.rightIconWidth
                      ? "is-valid"
                      : ""
                  }`}
                ></Field>
                <ErrorMessage
                  component="div"
                  name="rightIconWidth"
                  className="invalid-feedback"
                />
              </div>

              <div className="form-group">
                <label htmlFor="rightIconHeight">
                  Right Navigation Icon Height (In Pixels)
                </label>
                <Field
                  type="number"
                  name="rightIconHeight"
                  placeholder="Right Navigation Icon Height (e.g. 50)"
                  disabled={rightIconAsset ? false : true}
                  className={`form-control ${
                    touched.rightIconHeight && errors.rightIconHeight
                      ? "is-invalid"
                      : ""
                  } ${
                    touched.rightIconHeight && !errors.rightIconHeight
                      ? "is-valid"
                      : ""
                  }`}
                ></Field>
                <ErrorMessage
                  component="div"
                  name="rightIconHeight"
                  className="invalid-feedback"
                />
              </div>

              <div className="form-group">
                <label>Featured Image</label>
                <div className={`form-control asset-selector`}>
                  <PubHubAsset
                    asset={featuredImageAsset}
                    onChanged={(asset) => {
                      setFeaturedImageAsset(asset);
                    }}
                    maxFileSizeInBytes={5242880}
                    // acceptMimeTypes={["image/png", "image/jpeg"]}
                    assetType="image"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Navigation Logo Image</label>
                <div className={`form-control asset-selector`}>
                  <PubHubAsset
                    asset={navigationLogoAsset}
                    onChanged={(asset) => {
                      setNavigationLogoAsset(asset);
                    }}
                    maxFileSizeInBytes={5242880}
                    // acceptMimeTypes={["image/png", "image/jpeg"]}
                    assetType="image"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Favicon</label>
                <div className={`form-control asset-selector`}>
                  <PubHubAsset
                    asset={faviconAsset}
                    onChanged={(asset) => {
                      setFaviconAsset(asset);
                    }}
                    maxFileSizeInBytes={5242880}
                    // acceptMimeTypes={["image/png", "image/jpeg"]}
                    assetType="image"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Loading Icon</label>
                <div className={`form-control asset-selector`}>
                  <PubHubAsset
                    asset={loadingIconAsset}
                    onChanged={(asset) => {
                      setLoadingIconAsset(asset);
                    }}
                    maxFileSizeInBytes={5242880}
                    // acceptMimeTypes={["image/png", "image/jpeg"]}
                    assetType="image"
                  />
                </div>
              </div>

              {submitError && <Alert variant={"danger"}>{submitError}</Alert>}
              {submitSuccess && (
                <Alert variant={"success"}>{submitSuccess}</Alert>
              )}

              <div className="form-group">
                {submittingForm ? (
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                ) : (
                  <>
                    <button
                      type="submit"
                      className={`mb-2 btn btn-outline-primary ${
                        submittingForm ? "hide" : ""
                      }`}
                      style={{ marginRight: "5px" }}
                      disabled={submittingForm ? true : false}
                    >
                      Save
                    </button>
                  </>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </Col>
    </Row>
  );
}
